module.exports = __webpack_public_path__ + "static/media/susan3.488ff127.mp3";